import { Config } from "common/config";
import { EColors } from "common/styles";
import { Accordion } from "components/accordion/Accordion";
import { Button } from "components/buttons";
import { SpanColor } from "components/SpanColor";
import { Styled } from "components/Styled";
import { Fade } from "react-awesome-reveal";
import { accordionItems } from "./data";
import {
  ButtonWrapper,
  StyledContainerWrapper,
  StyledSectionFAQ,
  Styledtext,
  StyledTitle,
  StyledTitleMob,
} from "./styled";

export const FAQ = () => {
  const handleClick = () => {
    window.location.href = `#${Config.Section.contacts}`;
  };

  return (
    <StyledSectionFAQ color={EColors.white} id={Config.Section.questions}>
      <StyledContainerWrapper>
        <Styled.Half>
          <Fade direction="left" triggerOnce>
            <StyledTitle>
              Відповіді на{" "}
              <SpanColor bgColor={EColors.primary_200}>
                найчастіші питання
              </SpanColor>
            </StyledTitle>
            <Styled.H4>Залишились питання?</Styled.H4>
            <Styledtext>
              Зв’яжіться з нами, і ми надамо необхідні відповіді
            </Styledtext>
            <ButtonWrapper>
              <Button
                type="button"
                width="351px"
                height="60px"
                title="Зв'язатись з нами"
                onClick={handleClick}
              />
            </ButtonWrapper>
          </Fade>
        </Styled.Half>
        <Styled.Half>
          <Fade direction="right" triggerOnce>
            <StyledTitleMob>
              Відповіді на{" "}
              <SpanColor bgColor={EColors.primary_200}>
                найчастіші питання
              </SpanColor>
            </StyledTitleMob>
            <Accordion items={accordionItems} />
          </Fade>
        </Styled.Half>
      </StyledContainerWrapper>
    </StyledSectionFAQ>
  );
};
